(function () {
    var customMenu = {
        $menu: $('ul.menubar'),
        $maxWidth: window.innerWidth,
        $vPort: 'screen-md',

        init: function () {
            if (this.$menu.children('.dropdown').length) {
                customMenu.adaptWidth(false);
                customMenu.control();
            }
        },

        control: function () {
            $(document).on(customMenu.$vPort + '-on', function () {
                customMenu.adaptWidth(true);
            });
            $(document).on(customMenu.$vPort + '-off', function () {
                customMenu.adaptWidth(false);
            });
        },

        adaptWidth: function (isMobile) {
            // We need to set the width and max width of the dropdown menus
            customMenu.$maxWidth = window.innerWidth;
            customMenu.$menu.children('.dropdown').each(function (i, elem) {
                var targetMenu = $(elem).children('.dropdown__menu');
                var maxElemWidth = 'fill-content';
                var elemWidth = '100%';
                if (isMobile) {
                    targetMenu.css({'max-width': maxElemWidth, width: elemWidth});
                    customMenu.adaptHeight(targetMenu, elemWidth, true);
                } else {
                    maxElemWidth = customMenu.$maxWidth - elem.offsetLeft;
                    elemWidth = Math.ceil(targetMenu.children('li').length / 4) * 16;
                    if (elemWidth * 16 > maxElemWidth) {
                        targetMenu.css('overflow-x', 'auto');
                    }
                    targetMenu.css({'max-width': maxElemWidth, width: elemWidth + 'rem'});
                    customMenu.adaptHeight(
                        targetMenu,
                        elemWidth / Math.ceil(targetMenu.children('li').length / 4),
                        false
                    );
                }
            });
        },

        adaptHeight: function (elem, width, isMobile) {
            var maxHeight = 3.15; // Default height
            var target = $(elem).children('li');
            var rowsCount = 1;
            if (isMobile) {
                $(elem).css('max-height', 'fit-content');
                $(target).each(function (i, item) {
                    $(item).css('height', 'auto');
                });
            } else {
                maxHeight = Math.max.apply(
                    null,
                    $(target)
                        .map(function () {
                            rowsCount = Math.ceil(($(this).find('> a').text().length * 0.625) / width);
                            return rowsCount + 2;
                        })
                        .get()
                );
                $(elem).css('max-height', maxHeight * 4 + 1.6 + 'rem');
                $(target).each(function (i, item) {
                    $(item).css('height', maxHeight + 'rem');
                });
            }
        },
    };
    UX.customMenu = customMenu; // add to global namespace
})();
